export enum ReferentialType {
	None = 'none',
	Pays = 'pays',
	Devises = 'devises',
	Departements = 'departements',
	DegresRisque = 'degresRisque',
	TypesFacteurRisque = 'typesFacteurRisque',
	EtatsTraitement = 'etatsTraitement',
	ListeCodeEconomique = 'listeCodeEconomique',
	NaturesCompte = 'naturesCompte',
	NaturesAffaire = 'naturesAffaire',
	QualiteTiers = 'qualiteTiers',
	ModelesData = 'modelesData',
	TypesOperation = 'typesOperation',
	joursFermeture = 'joursFermeture',
	NaturesOperation = 'naturesOperation',
	SousMotif = 'sousMotif'
}
